import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 md:px-12 py-16 sm:py-24">
        <h1 className="text-5xl sm:text-6xl tracking-tight leading-none font-black mb-8" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <div className="prose prose-lg max-w-none text-base sm:text-lg leading-relaxed">
          <p className="mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Information We Collect
          </h2>
          <p className="mb-6">
            We collect information that you provide directly to us, including when you subscribe to our newsletter, 
            post comments, or contact us through our website.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            How We Use Your Information
          </h2>
          <p className="mb-6">
            We use the information we collect to provide, maintain, and improve our services, send you newsletters 
            and updates, respond to your comments and questions, and protect against fraudulent or illegal activity.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Information Sharing
          </h2>
          <p className="mb-6">
            We do not share your personal information with third parties except as described in this policy or with 
            your consent.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Cookies
          </h2>
          <p className="mb-6">
            We use cookies and similar technologies to collect information about your browsing activities and to 
            personalize your experience on our website.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Contact Us
          </h2>
          <p className="mb-6">
            If you have any questions about this Privacy Policy, please contact us at onlyone610@gmail.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
